import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function SectionCTA({
    kicker = "Prochaine étape",
    title = "Un projet à concrétiser ?",
    text = "Confiez-nous votre chantier. Nous étudions votre projet et vous répondons rapidement avec une proposition adaptée.",
    dark = true,
}) {
    return (
        <section
            className={`relative overflow-hidden ${dark ? "bg-navy-700 text-white" : "bg-concrete-50 text-navy-700"}`}
        >
            <div className={`absolute inset-0 ${dark ? "bg-topo-dark" : "bg-topo"} opacity-70 pointer-events-none`} />
            <div className="relative rcps-container py-16 md:py-24 grid md:grid-cols-12 gap-8 items-end">
                <div className="md:col-span-8">
                    <p className={`kicker ${dark ? "text-white/70" : ""}`}>
                        <span className="hairline" />
                        {kicker}
                    </p>
                    <h2 className="mt-4 font-heading text-3xl md:text-5xl font-semibold leading-[1.05] tracking-tight">
                        {title}
                    </h2>
                    <p className={`mt-5 text-base md:text-lg max-w-2xl ${dark ? "text-white/75" : "text-navy-700/75"}`}>
                        {text}
                    </p>
                </div>
                <div className="md:col-span-4 flex md:justify-end gap-3">
                    <Link
                        to="/contact"
                        data-testid="section-cta-primary"
                        className={`inline-flex items-center gap-2 h-12 px-6 rounded-md font-semibold transition ${
                            dark
                                ? "bg-white text-navy-700 hover:bg-concrete-50"
                                : "bg-navy-700 text-white hover:bg-navy-800"
                        }`}
                    >
                        Demander un devis <ArrowRight className="w-4 h-4" />
                    </Link>
                </div>
            </div>
        </section>
    );
}
